import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";

//Common modules
import { CoreModule } from "./core/core.module";
import { LayoutModule } from "./layout/layout.module";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { RoutingModule } from "./app-routing.module";
import { ApiUrls } from "./core/config/api-urls";
import { AppHeadings } from "./core/config/app-headings";
import { AppSettings } from "./core/config/app-settings";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { DateFormat } from "./core/config/date-format";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, DateAdapter } from "@angular/material/core";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RoutingModule,
    CoreModule,
    LayoutModule,
    SharedModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    // App-level configuration providers
    ApiUrls,
    AppHeadings,
    AppSettings,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, disableClose: true },
    },
    { provide: DateAdapter, useClass: DateFormat },
  ],
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    dateAdapter.setLocale("en-in"); // DD/MM/YYYY
  }
}
